import { ShieldCheck, Truck, Target, Heart, Users, Award } from "lucide-react";
import DisclosureBanner from "../components/DisclosureBanner";
import TeamGallery from "../components/TeamGallery";

export default function About() {
  return (
    <div>
      <DisclosureBanner />
      <section className="py-14 md:py-20 gradient-radial grain-overlay relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
          <img src="/logo.png" alt="Integrity Delivered" data-testid="about-logo" className="h-24 sm:h-32 w-auto mb-8 drop-shadow-[0_4px_16px_rgba(0,0,0,0.7)]" />
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">About Us</div>
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-white display">Baltimore's dedicated delivery partner.</h1>
          <p className="mt-5 text-slate-300 leading-relaxed text-lg">
            Integrity Delivered, Inc. is a locally owned and operated business that provides last-mile delivery services under contract with FedEx Ground. We're built on a simple idea: hire good people, treat them well, and deliver every package on time — safely and professionally.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10">
          <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8">
            <Target className="w-8 h-8 text-amber-400" />
            <h2 className="mt-4 text-2xl font-bold uppercase display text-white">Our Mission</h2>
            <p className="mt-3 text-slate-300 leading-relaxed">
              To operate the most reliable, safety-obsessed, driver-focused delivery service in the Greater Baltimore region — earning the trust of every household and business we serve, every single day.
            </p>
          </div>
          <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-8">
            <Heart className="w-8 h-8 text-amber-400" />
            <h2 className="mt-4 text-2xl font-bold uppercase display text-white">Our People</h2>
            <p className="mt-3 text-slate-300 leading-relaxed">
              Our drivers aren't gig workers — they're professionals. We invest in training, safety, and clear career pathways so that everyone who wears our uniform can be proud of the work they do.
            </p>
          </div>
        </div>
      </section>

      <TeamGallery />

      <section className="py-14 md:py-20 border-t border-slate-900 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Values We Live By</div>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold uppercase display text-white">Standards, not slogans.</h2>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {[
              { Icon: ShieldCheck, t: "Safety Above All", d: "From vehicle inspections to routing decisions, every action is filtered through a safety lens." },
              { Icon: Truck, t: "Operational Excellence", d: "We measure, review, and improve every route — because reliability is a habit, not a promise." },
              { Icon: Users, t: "Accountability", d: "Drivers, supervisors, and ownership share the same performance and integrity standards." },
              { Icon: Award, t: "Recognition", d: "Great work deserves to be seen. Our weekly recognition program celebrates the drivers who lead by example." },
              { Icon: Heart, t: "Community First", d: "We hire locally, invest locally, and treat every stop like a neighbor's front door." },
              { Icon: Target, t: "Continuous Improvement", d: "Feedback flows both ways — from customers, drivers, and partners — and it drives our decisions." },
            ].map((v, i) => (
              <div key={v.t} data-testid={`about-value-${i}`} className="rounded-xl border border-slate-800 bg-slate-900/60 p-6">
                <v.Icon className="w-6 h-6 text-amber-400" />
                <div className="mt-4 text-white font-bold display uppercase tracking-tight">{v.t}</div>
                <div className="mt-2 text-sm text-slate-400 leading-relaxed">{v.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-2xl md:text-3xl font-bold uppercase display text-white">Our FedEx Ground relationship</h3>
          <p className="mt-4 text-slate-300 leading-relaxed">
            Integrity Delivered, Inc. is an independent business entity that provides delivery services under a service provider agreement with FedEx Ground. We are solely responsible for our employees, vehicles, and day-to-day operations. FedEx Corporation is not our owner, employer, or agent, and this website is not affiliated with or endorsed by FedEx Corporation.
          </p>
        </div>
      </section>
    </div>
  );
}
